<template>
    <span>
        <v-tooltip
            color="black"
            left
            open-delay="1000"
        >
            <template #activator="{on, attrs}">
                <v-btn
                    v-bind="attrs"
                    v-on="on"
                    icon
                    small
                    @click="initChangeSettings"
                >
                    <v-icon
                        small
                        color="white"
                    >fas fa-cog</v-icon>
                </v-btn>
            </template>
            <span>Account Settings</span>
        </v-tooltip>

        <v-dialog
            max-width="500"
            v-model="accountSettingModal"
        >
            <v-card>
                <v-card-title>Change Account Settings</v-card-title>
                <v-card-text>
                    <h3 class="mb-2">Change Email</h3>
                    <p>Once you change your email, you will no longer be able to log in with your current email address.</p>
                    <form
                        action=""
                        id="changeEmailForm"
                        method="POST"
                        @submit.prevent="changeEmail"
                        class="mb-4"
                    >
                        <ValidationObserver v-slot="{invalid}">
                            <ValidationProvider
                                name="email"
                                rules="required|email|max:255|confirmed:emailConfirmation"
                                v-slot="{ errors }"
                                mode="lazy"
                            >
                                <v-text-field
                                    label="Email"
                                    name="newEmail"
                                    id="newEmail"
                                    type="newEmail"
                                    v-model="newEmail"
                                    outlined
                                    dense
                                    :error-messages="errors[0]"
                                />
                            </ValidationProvider>
                            <ValidationProvider
                                name="emailConfirmation"
                                rules="required|email|max:255"
                                v-slot="{ errors }"
                                vid="emailConfirmation"
                                mode="lazy"
                            >
                                <v-text-field
                                    label="Confirm Email"
                                    name="confirmEmail"
                                    id="confirmEmail"
                                    type="confirmEmail"
                                    v-model="emailConfirmation"
                                    outlined
                                    dense
                                    :error-messages="errors[0]"
                                />
                            </ValidationProvider>
                            <v-card-actions class="ma-0 pa-0">
                                <v-spacer />
                                <v-btn
                                    text
                                    @click="cancelChangeSettings"
                                >Cancel</v-btn>
                                <v-btn
                                    form="changeEmailForm"
                                    type="submit"
                                    color="primary"
                                    :disabled="invalid"
                                >Change Email</v-btn>
                            </v-card-actions>
                        </ValidationObserver>
                    </form>
                    <h3 class="mb-2">Change Password</h3>
                    <form
                        action=""
                        id="changePasswordForm"
                        method="POST"
                        @submit.prevent="changePassword"
                    >
                        <ValidationObserver v-slot="{invalid}">
                            <ValidationProvider
                                name="password"
                                rules="required|min:8|max:255|confirmed:passwordConfirmation"
                                v-slot="{ errors }"
                                mode="lazy"
                            >
                                <v-text-field
                                    label="Password"
                                    name="password"
                                    id="password"
                                    type="password"
                                    v-model="newPassword"
                                    outlined
                                    dense
                                    :error-messages="errors[0]"
                                />
                            </ValidationProvider>
                            <ValidationProvider
                                name="passwordConfirmation"
                                rules="required|min:8|max:255"
                                v-slot="{ errors }"
                                vid="passwordConfirmation"
                                mode="lazy"
                            >
                                <v-text-field
                                    label="Confirm Password"
                                    name="confirmPassword"
                                    id="confirmPassword"
                                    type="password"
                                    v-model="passwordConfirmation"
                                    outlined
                                    dense
                                    :error-messages="errors[0]"
                                />
                            </ValidationProvider>
                            <v-card-actions class="ma-0 pa-0">
                                <v-spacer />
                                <v-btn
                                    text
                                    @click="cancelChangeSettings"
                                >Cancel</v-btn>
                                <v-btn
                                    form="changePasswordForm"
                                    type="submit"
                                    color="primary"
                                    :disabled="invalid"
                                >Change Password</v-btn>
                            </v-card-actions>
                        </ValidationObserver>
                    </form>
                </v-card-text>
            </v-card>
        </v-dialog>
    </span>
</template>

<script>
import axios from 'axios';
import notify from '@/store/Common/notify';
export default {
    props: [],

    data() {
        return {
            newPassword: undefined,
            passwordConfirmation: undefined,
            newEmail: undefined,
            emailConfirmation: undefined,
            accountSettingModal: false
        };
    },

    mounted() {},

    methods: {
        initChangeSettings() {
            this.accountSettingModal = true;
        },

        changeEmail() {
            this.saveEmail()
                .then(() => {
                    this.closeSettingsModal();
                });
        },

        changePassword() {
            this.savePassword()
                .then(() => {
                    this.closeSettingsModal();
                });
        },

        saveEmail() {
            return new Promise((resolve, reject) => {
                axios.post('/api/user/change-email', {'email': this.newEmail})
                    .then((response) => {
                        resolve(response);
                        notify('Email Changed Successfully', 'success');
                        this.newEmail = undefined;
                        this.emailConfirmation = undefined;
                    })
                    .catch((error) => {
                        reject(error);
                        notify('Email Not Changed', 'error');
                    });
            });
        },

        savePassword() {
            return new Promise((resolve, reject) => {
                axios.post('/api/user/change-password', {'password': this.newPassword})
                    .then((response) => {
                        resolve(response);
                        notify('Password Changed Successfully', 'success');
                        this.newPassword = undefined;
                        this.passwordConfirmation = undefined;
                    })
                    .catch((error) => {
                        reject(error);
                        notify('Password Not Changed', 'error');
                    });
            });
        },

        cancelChangeSettings() {
            this.closeSettingsModal();
        },

        closeSettingsModal() {
            this.accountSettingModal = false;
        }
    }
};
</script>
